import React from 'react';
import Icon from '../../../components/AppIcon';

const HistoryStats = ({ stats }) => {
  const statCards = [
    {
      id: 'total-sessions',
      title: 'Total Sessions',
      value: stats.totalSessions.toLocaleString(),
      icon: 'Activity',
      color: 'text-primary bg-primary/10',
      change: stats.sessionsChange,
      changeType: stats.sessionsChange >= 0 ? 'increase' : 'decrease'
    },
    {
      id: 'emails-validated',
      title: 'Emails Validated',
      value: stats.totalEmailsValidated.toLocaleString(),
      icon: 'Mail',
      color: 'text-accent bg-accent/10',
      change: stats.emailsChange,
      changeType: stats.emailsChange >= 0 ? 'increase' : 'decrease'
    },
    {
      id: 'success-rate',
      title: 'Average Success Rate',
      value: `${stats.averageSuccessRate}%`,
      icon: 'CheckCircle',
      color: 'text-success bg-success/10',
      change: stats.successRateChange,
      changeType: stats.successRateChange >= 0 ? 'increase' : 'decrease'
    },
    {
      id: 'storage-used',
      title: 'Storage Used',
      value: stats.storageUsed,
      icon: 'HardDrive',
      color: 'text-warning bg-warning/10',
      change: stats.storageChange,
      changeType: stats.storageChange >= 0 ? 'increase' : 'decrease'
    }
  ];

  const getChangeIcon = (changeType) => {
    return changeType === 'increase' ? 'TrendingUp' : 'TrendingDown';
  };

  const getChangeColor = (changeType) => {
    return changeType === 'increase' ? 'text-success' : 'text-error';
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {statCards.map((stat) => (
        <div key={stat.id} className="bg-surface border border-border rounded-md p-6">
          <div className="flex items-center justify-between mb-4">
            <div className={`p-3 rounded-md ${stat.color}`}>
              <Icon name={stat.icon} size={20} />
            </div>
            {stat.change !== undefined && (
              <div className={`flex items-center space-x-1 ${getChangeColor(stat.changeType)}`}>
                <Icon name={getChangeIcon(stat.changeType)} size={14} />
                <span className="text-xs font-medium">
                  {Math.abs(stat.change)}%
                </span>
              </div>
            )}
          </div>
          
          <div className="space-y-1">
            <h3 className="text-2xl font-semibold text-text-primary">
              {stat.value}
            </h3>
            <p className="text-sm text-text-secondary">
              {stat.title}
            </p>
          </div>
          
          {stat.change !== undefined && (
            <div className="mt-3 pt-3 border-t border-border-light">
              <p className="text-xs text-text-secondary">
                {stat.changeType === 'increase' ? '+' : ''}{stat.change}% from last month
              </p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default HistoryStats;